
import { useState } from 'react';

function useForm(initialValues) {

    const [values, setValues] = useState(initialValues);
  
    function setValue(key, value) {
      setValues({
        ...values,
        [key]: value,
      })
    }
  
    function handleChange(e) {
        //const { getAttribute, value } = e.target;
        setValue(
          e.target.getAttribute('name'),
          e.target.value
        );
    }
  
    function clearForm() {
        setValues(initialValues);
    }
  
    return {
      clearForm,
      values,
      handleChange
    }
  }

  export default useForm;
  
